import { doc, updateDoc } from "firebase/firestore";
import { db } from "../../firebase";
import { getLocalStorageItem } from "../localStorage/getLocalStorage";

const UpdateAgentEmailFlag = async (agentId) => {
  try {
    const clientDocument = await doc(db, "clients", getLocalStorageItem("bid"));
    const agentDocument = await doc(clientDocument, "agents", agentId);
    const data = {
      email_sent: false,
    };
    return await updateDoc(agentDocument, data)
      .then((res) => true)
      .catch((err) => false);
  } catch (error) {
    console.log(error);
  }
};

export default UpdateAgentEmailFlag;
